import React, { useState} from "react";
import GeneralAccessManagement from "./GeneralAccess";
import RequestLeaveViewManagement from "./View";

import { isAllowedToDo } from "permissions-hub";
import { ACCEPTED_PERMISSIONS } from "constants";
import { isReadOnly } from "validations";

const RequestLeaveManagement = ({ permissions }) => {
  const isReadOnlyFlag = isReadOnly(permissions);

  const isAllowedToRead = isAllowedToDo(ACCEPTED_PERMISSIONS.read, permissions);
  const isAllowedToCreate = isAllowedToDo(
    ACCEPTED_PERMISSIONS.create,
    permissions
  );
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS.update,
    permissions
  );
  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS.delete,
    permissions
  );

  const currentDate = new Date();

  const [selectedMonthYear, setSelectedMonthYear] = useState({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear(),
  });

  const ManagementComponent = isReadOnlyFlag ? (
    <RequestLeaveViewManagement
      selectedMonthYear={selectedMonthYear}
      setSelectedMonthYear={setSelectedMonthYear}
    />
  ) : (
    <GeneralAccessManagement
      isAllowedToRead={isAllowedToRead}
      isAllowedToCreate={isAllowedToCreate}
      isAllowedToUpdate={isAllowedToUpdate}
      isAllowedToDelete={isAllowedToDelete}
      RequestLeaveViewManagement={RequestLeaveViewManagement}
      selectedMonthYear={selectedMonthYear}
      setSelectedMonthYear={setSelectedMonthYear}
    />
  );

  return ManagementComponent;
};

export default RequestLeaveManagement;
